import { PartnerLogo } from 'components/molecules/partner-logo'

interface PartnerSignInBannerProps {
	partnerName: string
	logo?: string | null
	/** What the page asks for: "Sign in" or "Sign up". */
	action: string
}

/** Shown on the auth pages when the visitor is on their way to connect a partner. */
export function PartnerSignInBanner({ partnerName, logo, action }: Readonly<PartnerSignInBannerProps>) {
	return (
		<div className="mb-4 flex w-full max-w-md items-center gap-3 rounded-2xl border border-info/40 bg-info/10 px-4 py-3">
			<PartnerLogo name={partnerName} logo={logo} className="h-9 w-9 shrink-0" />
			<p className="text-sm text-primary-text">
				{action} to connect <span className="font-semibold">{partnerName}</span> to your Loyalink account. Nothing
				is shared until you approve it.
			</p>
		</div>
	)
}
